import { render, staticRenderFns } from "./wwtService.vue?vue&type=template&id=5b9dc4dc&scoped=true&"
import script from "./wwtService.vue?vue&type=script&lang=js&"
export * from "./wwtService.vue?vue&type=script&lang=js&"
import style0 from "./wwtService.vue?vue&type=style&index=0&id=5b9dc4dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9dc4dc",
  null
  
)

export default component.exports